var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('h2',[_vm._v("Oops")]),_c('p',[_vm._v("有什麼錯誤發生了，請稍後再重試，如果持續發生，請聯絡網站管理員，謝謝")])])}]

export { render, staticRenderFns }